
"use client"

import * as React from "react"
import * as AspectRatioPrimitive from "@radix-ui/react-aspect-ratio"
import { cn } from "@/lib/utils"

interface AspectRatioProps extends React.ComponentPropsWithoutRef<typeof AspectRatioPrimitive.Root> {
  contentClassName?: string;
  centerContent?: boolean;
}

const AspectRatio = React.forwardRef<
  React.ElementRef<typeof AspectRatioPrimitive.Root>,
  AspectRatioProps
>(({ className, contentClassName, centerContent = false, children, ...props }, ref) => (
  <AspectRatioPrimitive.Root
    ref={ref}
    className={cn("relative w-full overflow-hidden", className)}
    {...props}
  >
    <div className={cn(
      "w-full h-full", 
      centerContent && "flex items-center justify-center",
      contentClassName
    )}>
      {children}
    </div>
  </AspectRatioPrimitive.Root>
))

AspectRatio.displayName = "AspectRatio"

export { AspectRatio }
